import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: '"SCProsperSans"',
  },
  palette: {
    primary: {
      main: '#3874CB', // fallback, will be overridden by CSS variables
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#062565', // fallback, will be overridden by CSS variables
      contrastText: '#FFFFFF',
    },
    tertiary: {
      main: '#D9D9D9', // fallback, will be overridden by CSS variables
      contrastText: '#000000',
    },
    success: {
      main: '#00B34F', // fallback, will be overridden by CSS variables
      contrastText: '#FFFFFF',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          padding: '4px 8px',
          fontSize: 'var(--default-font-size)',
          marginLeft: '2px',
          marginRight: '2px',
        },
        containedPrimary: {
          backgroundColor: 'var(--button-primary-background-color)',
          color: 'var(--button-primary-color)',
          '&:hover': {
            filter: 'brightness(0.95)',
            backgroundColor: 'var(--button-primary-background-color)',
          },
        },
        containedSecondary: {
          backgroundColor: 'var(--button-secondary-background-color)',
          color: 'var(--button-secondary-color)',
          '&:hover': {
            filter: 'brightness(0.95)',
            backgroundColor: 'var(--button-secondary-background-color)',
          },
        },
        containedSuccess: {
          backgroundColor: 'var(--button-success-background-color)',
          color: 'var(--button-success-color)',
          '&:hover': {
            filter: 'brightness(0.95)',
            backgroundColor: 'var(--button-success-background-color)',
        },
      },
      variants: [
        {
          props: { color: 'tertiary', variant: 'contained' },
          style: {
            backgroundColor: 'var(--button-tertiary-background-color)',
            color: 'var(--button-tertiary-color)',
            border: '1px solid var(--button-tertiary-border-color)',
            '&:hover': {
              filter: 'brightness(0.95)',
              backgroundColor: 'var(--button-tertiary-background-color)',
            },
          },
        },
        {
          props: { color: 'tertiary', variant: 'outlined' },
          style: {
            backgroundColor: 'transparent',
            color: 'var(--button-tertiary-background-color)',
            border: '1px solid var(--button-tertiary-border-color)',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.04)',
            },
          },
        },
        {
          props: { color: 'tertiary', variant: 'text' },
          style: {
            color: 'var(--button-tertiary-background-color)',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.04)',
            },
          },
        },
      ],
    },
    MuiTab:{
      styleOverrides:{
        root:{
          textTransform: 'none',
        }
      }
    }
  },
}
})

export default theme;
